import type { TRuleWithTheme } from '@ackee/fela';

import dividerImg from '../../../../../../static/images/divider.svg';

export const container: TRuleWithTheme = ({ theme: { colors } }) => ({
    display: 'flex',
    flexWrap: 'wrap',

    paddingLeft: '1.875rem',
    paddingTop: '0.25rem',
    paddingBottom: '0.25rem',

    marginLeft: '0.3125rem',
    marginTop: '2rem',

    tablet: {
        flexWrap: 'nowrap',
    },

    borderLeft: `0.0625rem solid ${colors.lightGrey}`,
    position: 'relative',

    '&:before': {
        content: `url(${dividerImg})`,
        position: 'absolute',
        left: '-0.3125rem',
        top: 0,
    },
});

export const textContainer: TRuleWithTheme = () => ({
    marginTop: '1.5rem',

    tablet: {
        marginTop: 0,
    },
});

export const image: TRuleWithTheme = () => ({
    marginRight: '2.1875rem',
    height: '4.875rem',
});

export const extendLink: TRuleWithTheme = ({ theme: { colors } }) => ({
    fontWeight: 800,
    fontSize: '1rem',
    lineHeight: '1.5rem',
    color: colors.black,
});

export const extendNameText: TRuleWithTheme = () => ({
    marginTop: '-0.25rem',
    marginBottom: '0.0625rem',
});

export const extendRoleText: TRuleWithTheme = ({ theme: { colors } }) => ({
    fontWeight: 500,
    fontSize: '0.875rem',
    fontStyle: 'italic',
    lineHeight: '1.125rem',
    color: colors.darkGrey,
    marginBottom: '1.75rem',
});
